import React from 'react';

import { maxIndex, line, groups, curveMonotoneX } from 'd3';


export const Marks = ( {data, x, y, color, onHover, hovered, threshold=0.05}) => {
  const fa_line = line().curve(curveMonotoneX)
      .x(d=>x(d.iteration))
      .y(d=>y(d.probability));

  return groups(data.sort(d=>d.assay), d=>d.assay)
    .map(([assay, assay_data]) => {
      return groups(assay_data.sort(d => d.lipid_class), d => d.lipid_class)
        .map(([lipid_class, lc_data]) => {
          return groups(lc_data.sort(d => d.fatty_acid), d => d.fatty_acid)
            .map(([fatty_acid, fa_data]) => {
              const end = fa_data[maxIndex(fa_data, d => d.iteration)];
              const colored = ((hovered === null) & (end.probability > threshold)) || (hovered === fatty_acid);
              const lineColor = color(fatty_acid);
              if (colored) {
                return <>
                  <text 
                    className="text-annotation"
                    x={x(end.iteration)}
                    y={y(end.probability)}
                    fill={lineColor}
                    dy=".32em"
                    dx="10"
                    >
                    {fatty_acid}
                  </text>
                  <path
                    className="active path active-path"
                    style={{stroke: lineColor,
                      opacity: 1, strokeWidth: 2, fill: "none",
                    }}
                    d={fa_line(fa_data)}
                  />
                  <path
                    className="hover-path"
                    id={fatty_acid}
                    d={fa_line(fa_data)}
                    style={{stroke: "transparent", fill: "none", strokeWidth: 30}}
                    onMouseEnter={e => onHover(e.target.id)}
                    onMouseLeave={e => onHover(null)}
                  />
                </>
              }
              return (
                <>
                  <path
                    className="inactive path"
                    style={{
                      stroke: "#c0c0bb",
                      opacity: 0.9, strokeWidth: 1, fill: "none",
                    }}
                    d={fa_line(fa_data)}
                  />
                  <path
                    className="hover-path"
                    id={fatty_acid}
                    style={{stroke: "transparent", fill: "none", strokeWidth: 30}}
                    d={fa_line(fa_data)}
                    onMouseEnter={e => onHover(e.target.id)}
                    onMouseLeave={e => onHover(null)}
                  />
                </>
              )
            });
        })
    }
  );
};
